/** @jsxRuntime classic */

/** @jsx jsx */

/** @jsxFrag React.Fragment */
var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}; // @ts-check


import { TextInput } from '@bottlebooks/gatsby-design-system';
import { Field } from 'formik';
import { jsx } from 'theme-ui';
import FieldLayout from './FieldLayout';
import useFormTheme from './useFormTheme';
import React from 'react';
/**
 *
 * @param {object} props
 * @param {string} props.name The path to the field in lodash-like dot path, such as `social.facebook` or `friends[0].firstName`.
 * @param {string | JSX.Element} props.label The localized label.
 * @param {string | JSX.Element} [props.description] The description.
 * @param {React.ReactNode} [props.children] The options as children. Preferred over props.options.
 * @param {Array<{ key: string; label: string; }>} [props.options] The options.
 * @returns
 */

export default function SelectField(_a) {
  var name = _a.name,
      label = _a.label,
      description = _a.description,
      rest = __rest(_a, ["name", "label", "description"]);

  var theme = useFormTheme();
  return jsx(FieldLayout, {
    name: name,
    label: label,
    description: description
  }, jsx(Field, Object.assign({
    name: name,
    as: SelectInput,
    sx: theme === null || theme === void 0 ? void 0 : theme.input
  }, rest)));
}

function SelectInput(_a) {
  var options = _a.options,
      children = _a.children,
      rest = __rest(_a, ["options", "children"]);

  return jsx(TextInput, Object.assign({
    as: "select"
  }, rest), children ? children : jsx(React.Fragment, null, jsx("option", {
    value: ""
  }, "(Select one)"), options === null || options === void 0 ? void 0 : options.map(function (_ref) {
    var key = _ref.key,
        label = _ref.label;
    return jsx("option", {
      key: key,
      value: key
    }, label);
  })));
}